import React from 'react';
import Button from 'antd/lib/button';
import Icon from '@ant-design/icons';

import CVATTooltip from 'components/common/cvat-tooltip';
import { MoonIcon, SunIcon } from 'icons';
import { useTheme } from 'theme/theme';
import { t } from 'utils/i18n';

interface Props {
    className?: string;
}

export default function ThemeToggle({ className }: Props): JSX.Element {
    const [theme, setTheme] = useTheme();
    const label = theme === 'dark' ? t('Light theme') : t('Dark theme');

    return (
        <CVATTooltip title={label}>
            <Button
                type='text'
                className={`cvat-theme-toggle ${className ?? ''}`.trim()}
                aria-label={label}
                icon={<Icon component={theme === 'dark' ? SunIcon : MoonIcon} />}
                onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
            />
        </CVATTooltip>
    );
}
